<!-- 慈福项目 -->
<template>
  <div>
    <PCNavbar />
    <CarouselHome type="project" />
     <div class="main-wrap">
      <div class="block-wrap">
        <div class="tab">
          <div class="tab-item" :class="{ current: current == index + 1 }" @click="toggle(index + 1)" v-for="(item, index) in cateList" :key="index">{{ item.title }}</div>
        </div>
      </div>
    </div>
    <ProjectView :content="content" :key="dateVal" :cateList="cateList"/>
    <Footer />
  </div>
</template>

<script>
// import CifuAPI from "@/utils/api";
import PCNavbar from "@/components/navbar/index";
import CarouselHome from "@/components/carousel_home/index";
import ProjectView from "@/components/projectView/projectView";
import Footer from "@/components/footer/index";
import CifuAPI from "@/utils/api";

export default {
  name: "Project",
  components: {
    PCNavbar,
    CarouselHome,
    ProjectView,
    Footer,
  },
  data() {
    return {
      current: 1,
      cateList: [],
      content: '',
      dateVal: Number(new Date())
    };
  },
  async created() {
    await this.getCateList()
    this.$watch(
      "$route",
      (to) => {
        const index = to.params.id || 1;
        this.toggle(index);
      },
      { immediate: true }
    );
  },
  methods: {
    async getCateList() {
      let res = await CifuAPI.getCateList()
      if (res.code == 1) {
        this.cateList = res.data
        if (res.data[0]) {
          this.content = res.data[0].desc
        }
      }
    },
    toggle(index) {
      this.content = ''
      if (this.cateList[index - 1]) {
        this.content = this.cateList[index - 1].desc
      }
      this.dateVal = Number(new Date())
      this.current = index;
      this.$store.dispatch("setMenuActive", "/project?type=" + index);
      // 更新路由参数
      this.$router.push({
        path: `/project/${index}`,
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.cifu-project-page {
  // 慈福项目页面图片优化
  
  
  // 确保项目展示图片正确显示
  
  // 页面整体样式优化
  .main-wrap {
    width: 100% !important;
    min-width: 1400px !important;
    background: #fff;
    padding: 40px 0;
    .block-wrap {
      width: 100% !important;
      min-width: 1400px;
      margin: 0 auto;
      padding: 0 20px;
    }
  }
  
  // 标签页样式优化
  .tab {
    display: flex;
    justify-content: space-between;
    margin-bottom: 40px;
    border-bottom: 2px solid #e0e0e0;
    
    .tab-item {
      flex: 1;
      text-align: center;
      padding: 20px 0;
      cursor: pointer;
      transition: all 0.3s ease;
      border-bottom: 3px solid transparent;
      
      &:hover {
        color: #663301;
      }
      
      &.current {
        color: #663301;
        border-bottom-color: #fbce00;
      }
    }
  }
  
  // 移动端优化
  // @media screen and (max-width: 768px) {
  //   .main-wrap {
  //     padding: 20px 0;
      
  //     .block-wrap {
  //       padding: 0 15px;
  //     }
  //   }
    
  //   .tab {
  //     flex-direction: column;
  //     margin-bottom: 20px;
      
  //     .tab-item {
  //       padding: 15px 0;
  //       border-bottom: 1px solid #e0e0e0;
        
  //       &.current {
  //         border-bottom-color: #fbce00;
  //       }
  //     }
  //   }
  // }
}
</style>
